<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row" style="margin-top: 100px">
          <div class="col-md-2">
            <!-- <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Saldo PPN</span></h5>
                <h3 class="my-3">
                </h3>
              </div>
            </div> -->
          </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-small-toolbar">
                    <div>
                        <h4 class="text-primary">Laporan Audit</h4>
                        <div class="form-inline">
                          <span><b>Company:</b></span>
                          <select v-model="company_no" class="form-control">
                            <option value="">-- All --</option>
                            <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                          </select>
                          <span><b>Date:</b></span>
                          <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                          <button type="button" class="btn btn-sm btn-hard-primary waves-light waves-effect ml-2" @click="refreshList">
                            <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                          </button>
                          <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-print" aria-hidden="true"></i> Print
                          </button>
                          <div class="dropdown-menu" aria-labelledby="print">
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-item mb-0 table-sm table-striped table-hover">
                                <thead>
                                    <th>Data</th>
                                    <th class="text-right">Amount</th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Penerimaan Tunai</td>
                                        <td class="text-right">
                                            <span v-if="audit.paymentTunaiStatus === false">{{ audit.paymentTunai | currency }}</span>
                                            <span v-else class="spinner-border spinner-border-sm" role="status"></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Penerimaan Transfer</td>
                                        <td class="text-right">
                                            <span v-if="audit.paymentTransferStatus === false">{{ audit.paymentTransfer | currency }}</span>
                                            <span v-else class="spinner-border spinner-border-sm" role="status"></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Penerimaan Giro</td>
                                        <td class="text-right">
                                            <span v-if="audit.paymentGiroStatus === false">{{ audit.paymentGiro | currency }}</span>
                                            <span v-else class="spinner-border spinner-border-sm" role="status"></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Penerimaan Uang Muka</td>
                                        <td class="text-right">
                                            <span v-if="audit.paymentUangMukaStatus === false">{{ audit.paymentUangMuka | currency }}</span>
                                            <span v-else class="spinner-border spinner-border-sm" role="status"></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Saldo Giro Belum Cair</td>
                                        <td class="text-right">
                                            <span v-if="audit.paymentGiroNotFinishStatus === false">{{ audit.paymentGiroNotFinish | currency }}</span>
                                            <span v-else class="spinner-border spinner-border-sm" role="status"></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Hutang</td>
                                        <td class="text-right">
                                            <span v-if="audit.hutangStatus === false">{{ audit.hutang | currency }}</span>
                                            <span v-else class="spinner-border spinner-border-sm" role="status"></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Piutang</td>
                                        <td class="text-right">
                                            <span v-if="audit.piutangStatus === false">{{ audit.piutang | currency }}</span>
                                            <span v-else class="spinner-border spinner-border-sm" role="status"></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Pembelian</td>
                                        <td class="text-right">
                                            <span v-if="audit.pembelianStatus === false">{{ audit.pembelian | currency }}</span>
                                            <span v-else class="spinner-border spinner-border-sm" role="status"></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Penjualan</td>
                                        <td class="text-right">
                                            <span v-if="audit.penjualanStatus === false">{{ audit.penjualan | currency }}</span>
                                            <span v-else class="spinner-border spinner-border-sm" role="status"></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Sisa Kas Besar Pemasukan</td>
                                        <td class="text-right">
                                            <span v-if="audit.sisaKasBesarPemasukanStatus === false">{{ audit.sisaKasBesarPemasukan | currency }}</span>
                                            <span v-else class="spinner-border spinner-border-sm" role="status"></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Sisa Kas Besar</td>
                                        <td class="text-right">
                                            <span v-if="audit.sisaKasBesarStatus === false">{{ audit.sisaKasBesar | currency }}</span>
                                            <span v-else class="spinner-border spinner-border-sm" role="status"></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Sisa Kas Kecil</td>
                                        <td class="text-right">
                                            <span v-if="audit.sisaKasKecilStatus === false">{{ audit.sisaKasKecil | currency }}</span>
                                            <span v-else class="spinner-border spinner-border-sm" role="status"></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Sisa Saldo Bank BCA</td>
                                        <td class="text-right">
                                            <span v-if="audit.sisaBankBcaStatus === false">{{ audit.sisaBankBca | currency }}</span>
                                            <span v-else class="spinner-border spinner-border-sm" role="status"></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Sisa Saldo Bank Danamon</td>
                                        <td class="text-right">
                                            <span v-if="audit.sisaBankDanamonStatus === false">{{ audit.sisaBankDanamon | currency }}</span>
                                            <span v-else class="spinner-border spinner-border-sm" role="status"></span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import DatePicker from 'vue2-datepicker'
import { getHeader, reportUrl, purchasingUrl, salesUrl, report2Url } from '../../config'

export default {
  name: 'ReportAudit',
  props: ['scroll'],
  components: {
    Loading,
    DatePicker
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      audit: {
        paymentTunai: 0,
        paymentTunaiStatus: false,
        paymentTransfer: 0,
        paymentTransferStatus: false,
        paymentGiro: 0,
        paymentGiroStatus: false,
        paymentUangMuka: 0,
        paymentUangMukaStatus: false,
        paymentGiroNotFinish: 0,
        paymentGiroNotFinishStatus: false,
        hutang: 0,
        hutangStatus: false,
        piutang: 0,
        piutangStatus: false,
        pembelian: 0,
        pembelianStatus: false,
        penjualan: 0,
        penjualanStatus: false,
        sisaKasKecil: 0,
        sisaKasKecilStatus: false,
        sisaKasBesar: 0,
        sisaKasBesarStatus: false,
        sisaKasBesarPemasukan: 0,
        sisaKasBesarPemasukanStatus: false,
        sisaBankBca: 0,
        sisaBankBcaStatus: false,
        sisaBankDanamon: 0,
        sisaBankDanamonStatus: false
      },
      filterType: [],
      saldoTax: 0,
      loadingSales: true,
      selected: [],
      startDate: [date1, date2],
      term: 0,
      salesman_id: '',
      company_no: '',
      year: '2022',
      date: null,
      typeData: null,
      period: [],
      dataRaw: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      authUser: state => state.users.authUser
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterType.length > 0) {
          for (let i = 0; i < this.filterType.length; i++) {
            if (d.type === this.filterType[i]) {
              return d
            }
          }
        } else {
          return d
        }
      })
    }
  },
  methods: {
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.audit.paymentTunaiStatus = true
      this.audit.paymentTransferStatus = true
      this.audit.paymentGiroStatus = true
      this.audit.paymentUangMukaStatus = true
      this.audit.paymentGiroNotFinishStatus = true
      this.audit.hutangStatus = true
      this.audit.piutangStatus = true
      this.audit.pembelianStatus = true
      this.audit.penjualanStatus = true
      this.audit.sisaKasKecilStatus = true
      this.audit.sisaKasBesarStatus = true
      this.audit.sisaKasBesarPemasukanStatus = true
      this.audit.sisaBankBcaStatus = true
      this.audit.sisaBankDanamonStatus = true
      this.selected = []
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no,
        category: 'sales'
      }
      console.log(reportUrl + '/audit-payment')
      await axios.post(reportUrl + '/audit-payment', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data)
          this.audit.paymentTunai = response.data.total_tunai
          this.audit.paymentTransfer = response.data.total_transfer
          this.audit.paymentGiro = response.data.total_giro
          this.audit.paymentUangMuka = response.data.total_uangmuka
          //  loading hide
          this.audit.paymentTunaiStatus = false
          this.audit.paymentTransferStatus = false
          this.audit.paymentGiroStatus = false
          this.audit.paymentUangMukaStatus = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Payment', error.response.data.message, 'error')
          throw error
        })
      var obj2 = {
        date: end,
        company_no: this.company_no,
        category: 'sales'
      }
      console.log(obj2)
      console.log(reportUrl + '/audit-payment-giro-not-finish')
      await axios.post(reportUrl + '/audit-payment-giro-not-finish', obj2, { headers: getHeader() })
        .then(response => {
          console.log(response.data)
          this.audit.paymentGiroNotFinish = response.data.total_giro
          this.audit.paymentGiroNotFinishStatus = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response.data.messgae)
          this.$swal('Giro', error.response.data.message, 'error')
          throw error
        })
      await axios.post(purchasingUrl + '/hutang-overdue', obj2, { headers: getHeader() })
        .then(response => {
          this.audit.hutang = response.data.total
          this.audit.hutangStatus = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Hutang', error.response.data.message, 'error')
          throw error
        })
      var objPiutang = {
        begin: begin,
        end: end,
        company_no: this.company_no
      }
      await axios.post(reportUrl + '/audit-piutang', objPiutang, { headers: getHeader() })
        .then(response => {
          this.audit.piutang = response.data.total
          this.audit.piutangStatus = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Piutang', error.response.data.message, 'error')
          throw error
        })
      await axios.get(purchasingUrl + '?begin=' + begin + '&end=' + end + '&company=' + this.company_no, { headers: getHeader() })
        .then(response => {
          this.audit.pembelian = response.data.total
          this.audit.pembelianStatus = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Pembelian', error.response.data.message, 'error')
          throw error
        })
      await axios.get(salesUrl + '?begin=' + begin + '&end=' + end + '&company=' + this.company_no, { headers: getHeader() })
        .then(response => {
          this.audit.penjualan = response.data.total
          this.audit.penjualanStatus = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Penjualan', error.response.data.message, 'error')
          throw error
        })
      await this.getKasKecil()
      await this.getKasBesar()
      await this.getKasBesarPemasukan()
      await this.getBankBca()
      await this.getBankDanamon()
    },
    async getKasKecil () {
      // const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var objCOH = {
        begin: null,
        end: end,
        company_no: this.company_no,
        type: 'kas-kecil'
      }
      await axios.post(reportUrl + '/audit-cash-on-hand', objCOH, { headers: getHeader() })
        .then(response => {
          this.audit.sisaKasKecil = response.data.saldo
          this.audit.sisaKasKecilStatus = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Kas Kecil', error.response.data.message, 'error')
          throw error
        })
    },
    async getKasBesar () {
      // const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var objCOH = {
        begin: null,
        end: end,
        company_no: this.company_no,
        type: 'kas-besar-pengeluaran'
      }
      await axios.post(reportUrl + '/audit-cash-on-hand', objCOH, { headers: getHeader() })
        .then(response => {
          this.audit.sisaKasBesar = response.data.saldo
          this.audit.sisaKasBesarStatus = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Kas Kecil', error.response.data.message, 'error')
          throw error
        })
    },
    async getKasBesarPemasukan () {
      // const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var objCOH = {
        begin: null,
        end: end,
        company_no: this.company_no,
        type: 'kas-besar-pemasukan'
      }
      await axios.post(reportUrl + '/audit-cash-on-hand', objCOH, { headers: getHeader() })
        .then(response => {
          this.audit.sisaKasBesarPemasukan = response.data.saldo
          this.audit.sisaKasBesarPemasukanStatus = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Kas Kecil', error.response.data.message, 'error')
          throw error
        })
    },
    async getBankBca () {
      // const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var objCOH = {
        begin: null,
        end: end,
        company_no: this.company_no,
        type: 'bank-bca'
      }
      await axios.post(reportUrl + '/audit-cash-on-hand', objCOH, { headers: getHeader() })
        .then(response => {
          this.audit.sisaBankBca = response.data.saldo
          this.audit.sisaBankBcaStatus = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Bank BCA', error.response.data.message, 'error')
          throw error
        })
    },
    async getBankDanamon () {
      // const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var objCOH = {
        begin: null,
        end: end,
        company_no: this.company_no,
        type: 'bank-danamon'
      }
      await axios.post(reportUrl + '/audit-cash-on-hand', objCOH, { headers: getHeader() })
        .then(response => {
          this.audit.sisaBankDanamon = response.data.saldo
          this.audit.sisaBankDanamonStatus = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Bank Danamon', error.response.data.message, 'error')
          throw error
        })
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        data: this.audit
      }
      console.log(data)
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      await axios.post(report2Url + '/audit', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style scoped>
.header-period {
    background-color: #6FB56F;
    color: white;
}
.text-ref-sales {
    color: #28A745;
    cursor: pointer;
}
</style>
